import React from 'react';

import { DODGER_BLUE, WHITE } from '@constant/colors';

const Custom = () => (
  <svg viewBox="0 0 70 45">
    <g fill="none" fillRule="evenodd">
      <rect fill={DODGER_BLUE} width="70" height="45" rx="5" />
      <path
        d="M45.757 19.692c.218-.214.295-.532.2-.82-.097-.29-.35-.5-.653-.543l-6.21-.876c-.264-.036-.492-.2-.61-.437l-2.8-5.57c-.136-.273-.416-.447-.723-.447s-.587.174-.722.448l-2.746 5.613c-.117.237-.343.4-.605.438l-6.202.93c-.302.045-.553.258-.647.548-.093.29-.013.607.207.82l4.513 4.33c.19.184.28.45.235.71l-1.034 6.148c-.05.3.075.604.323.78.25.18.578.2.85.058L34.67 28.9c.236-.123.517-.123.75 0l5.565 2.865c.272.14.6.115.847-.065s.37-.484.317-.784l-1.1-6.14c-.05-.258.033-.524.22-.71l4.487-4.374z"
        fill={WHITE}
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default Custom;
